const formMeta = {
    formAction: '',
    iscompleted: false,
}

export const conceptAndViabilityDefaultValues = {

    final_feasibility_validation: {
        feasibility_status: '',
        key_constraints_summary: '',
        ...formMeta,
    },

    cost_benefit_final_model: {
        analysis_mode_selector: 'cba',
        total_project_cost: '',
        total_economic_benefit: '',
        cost_per_outcome_unit: '',
        total_outcome_units_delivered: '',
        ...formMeta,
    },

    fiscal_sustainability_ifsa: {
        final_fiscal_affordability_index: '',
        final_contingent_liability_exposure: '',
        long_term_fiscal_impact_score: '',
        ...formMeta,
    },

    risk_finalisation_engine: {
        ...formMeta,
    },

    long_term_asset_management: {
        expenditure_statement: "",
        funding_statement: "",
        cashflow_statement: "",
        contingent_liability_statement: "",
        ...formMeta,
    },

    final_investment_decision_engine_core_output: {
        ...formMeta,
    },

    esg_final_check: {
        gender_responsive_impact_compliance: '',
        social_benefit_index: '',
        environmental_compliance_status: '',
        sustainability_certification_status: '',
        social_impact_index: 0,
        overall_eia_summary_and_environmental_authorisation_status: '',
        key_environmental_impact_findings: '',
        key_social_impact_findings: '',
        gender_impact_findings: '',
        mitigation_measures_empr_summary: '',
        residual_impacts_acceptability: '',
        environmental_authorisation_conditions_compliance_status: '',
        ...formMeta,
    },

    infrastructure_master_plan: {
        master_plan_definition: '',
        ...formMeta,
    },

    institutional_and_operational_readiness: {
        institutional_and_operational_readiness_assessment: "",
        transformation_vision_objectives: "",
        bbbee_strategy_compliance_plan: "",
        gender_mainstreaming_youth_development_strategy: "",
        institutional_capacity_building_skills_development_plan: "",
        organisational_culture_change_programme: "",
        procurement_transformation_strategy: "",
        transformation_monitoring_evaluation_reporting: "",
        ...formMeta,
    },

    project_communication_and_stakeholder_engagement_plan: {
        investor_engagement_strategies: '',
        community_participation: '',
        government_regulatory_interactions: '',
        collaboration_partner_strategy: '',
        public_interest_considerations: '',
        ...formMeta,
    },

    digital_technology_leverage: {
        digital_technology_leverage: "",
        ...formMeta,
    },

    supervision_reporting_and_evaluation: {
        supervision_framework: '',
        reporting_framework: '',
        evaluation_framework: '',
        me_framework_kpi_data_source: '',
        me_responsibility_feedback_loops: '',
        reporting_frequency_format: '',
        evaluation_schedule: '',
        incentives_for_successful_delivery: '',
        penalties_for_non_performance: '',
        ...formMeta,
    },

    documents: {
        documents: [],

        ...formMeta,
    },

    project_plan: {
        ...formMeta,
    },

    economic_and_commercial_viability: {
        value_for_money_financial_assessment: '',
        summary_financial_vfm_findings: '',
        benefit_analysis_financial_quantification: '',
        summary_financial_benefit_findings: '',
        risk_evaluation_financial_risk_costing: '',
        summary_financial_risk_findings: '',
        economic_multipliers_financial_returns: '',
        summary_economic_multiplier_financial_findings: '',
        economies_of_scale_whole_life_cost_savings: '',
        summary_economies_of_scale_financial_findings: '',
        cost_effectiveness_unit_cost_metrics: '',
        summary_cea_financial_findings: '',
        social_economic_financial_monetisation: '',
        summary_social_economic_financial_findings: '',
        ...formMeta
    },

    implementation_strategy: {
        implementation_strategy_overview: "",

        asisa_investment_framework_alignment: "",

        esg_policy_statement_integration_approach: "",
        esg_environmental: "",
        esg_social: "",
        esg_governance: "",

        institutional_investor_funding_mobilisation_strategy: "",
        blended_finance_structure: "",
        institutional_investor_participation_requirements: "",

        due_diligence_framework_standards: "",

        impact_reporting_disclosure_commitments: "",
        impact_measurement_framework: "",

        asisa_disclosure_framework: "",
        stewardship_arrangements_crisa_alignment: "",

        asisa_risk_management_framework: "",

        implementation_plan_phasing_schedule: "",
        implementation_monitoring_evaluation: "",

        exit_strategy_liquidity_provision: "",
        ...formMeta
    },

    risk_statement: {
        risk_statement_problem_statement: '',
        risk_statement_risk_context: '',
        sensitivity_analysis_overview: '',
        sensitivity_analysis_conclusion: '',
        overall_risk_statement: '',
        ...formMeta
    },

    economic_multiplier_and_macroeconomics_benefits: {
        // Section 1: GDP Contribution & Economic Growth
        gdp_contribution_estimate: '',
        regional_economic_growth_effects: '',

        // Section 2: Employment Multipliers
        direct_employment: '',
        indirect_employment: '',
        induced_employment: '',

        // Section 3: Sector Multiplier & Supply Chain Effects
        sector_economic_multiplier: '',
        supply_chain_local_economic_development: '',
        productivity_trade_facilitation: '',

        // Section 4: Social Returns & Fiscal Benefits
        poverty_reduction_equity_impact: '',
        fiscal_returns_to_government: '',
        sdg_macroeconomic_policy_alignment: '',

        // Section 5: Macroeconomic Risk Factors
        macroeconomic_risks_sensitivity: '',

        ...formMeta
    },

    financial_requirements_and_funding_strategy: {
        cost_breakdown: "",
        funding_model: "",
        revenue_strategy: "",
        ...formMeta
    },

    summary_of_option_considered: {
        base_case_description: "",
        preferred_option: 0,
        preferred_option_government_objectives_justification: "",
        value_for_money_conclusion: "",
        supporting_documentation_reference: "",
        ...formMeta
    },
    approval_submit: {}
}

export type IConceptAndViabilityDefaultValues =
    typeof conceptAndViabilityDefaultValues